import DebtRepaymentPage from './DebtRepaymentPage'

export default DebtRepaymentPage
